/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import { StyledButton } from '@/components/atoms'
import { Footer, NavbarApp } from '@/components/molecules'
import route_list from '@/constant/routeUrl'
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'

const PrivacyPilicy = () => {
	const { t } = useTranslation('privacy')
	const router = useRouter()

	const onToggleLanguageClick = () => {
		const changeTo = router.locale === 'en' ? 'id' : 'en'
		const { pathname, asPath, query } = router
		router.push({ pathname, query }, asPath, { locale: changeTo })
	}

  // <div
  //           dangerouslySetInnerHTML={{__html: t('privacyPolicy')}}
  //         />
          
	return (
		<div className='tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-w-full'>
			<div className='tw-newsroom-banner' id='newsroom-banner'>
				<div className='tw-m-auto md:tw-py-16 md:tw-px-0 tw-py-8 tw-px-4 tw-max-w-6xl tw-mx-auto'>
					<h2 className='tw-text-white md:tw-text-5xl tw-text-2xl tw-font-bold tw-mb-5'>
						{t('privacy.title')}
					</h2>
					<span className='tw-text-white tw-text-sm tw-text-justify tw-flex'>
            {t('privacy.description')}
					</span>
				</div>
			</div>
			<div className='tw-w-full tw-min-h-[500px] tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-white md:tw-rounded-[40px] tw-rounded-[20px]'>
				<div className='tw-newsroom-container'>
					<div className='tw-max-w-6xl tw-mx-auto tw-my-20 md:tw-px-0 tw-px-4 tw-text-justify'>
						<p className='tw-mb-4' dangerouslySetInnerHTML={{__html: t('privacy.desc_p1')}}></p>
						<p className='tw-mb-4'>{t('privacy.desc_p2')}</p>
						<p className='tw-mb-4'>{t('privacy.desc_p3')}</p>
            <p className='tw-mb-4' dangerouslySetInnerHTML={{__html: t('privacy.desc_p4')}}></p>

						<h2 className='tw-text-2xl tw-font-bold tw-mt-8 tw-mb-1'>
              {t('privacy.point1.title')}
						</h2>
						<p>
              {t('privacy.point1.desc')}
						</p>

						<h2 className='tw-text-2xl tw-font-bold tw-mt-8 tw-mb-1'>
							{t('privacy.point2.title')}
						</h2>
						<p>
              {t('privacy.point2.desc')}
						</p>

						<h2 className='tw-text-2xl tw-font-bold tw-mt-8 tw-mb-1'>{t('privacy.point3.title')}</h2>
						<p>
              {t('privacy.point3.desc')}
						</p>
						<p>
              {t('privacy.point3.desc2')}
						</p>

						<h2 className='tw-text-2xl tw-font-bold tw-mt-8 tw-mb-1'>
							{t('privacy.point4.title')}
						</h2>
						<p>
							{t('privacy.point4.desc')}
						</p>
						<ul className='tw-list-disc tw-ml-8' dangerouslySetInnerHTML={{__html: t('privacy.point4.li')}}>
						</ul>
						<p>
							{t('privacy.point4.desc2')}
						</p>

						<h2 className='tw-text-2xl tw-font-bold tw-mt-8 tw-mb-1'>
							{t('privacy.point5.title')}
						</h2>
						<p>
							{t('privacy.point5.desc')}
						</p>

						<h2 className='tw-text-2xl tw-font-bold tw-mt-8 tw-mb-1'>
							{t('privacy.point6.title')}
						</h2>
						<p>
							{t('privacy.point6.desc')}
						</p>

						<h2 className='tw-text-2xl tw-font-bold tw-mt-8 tw-mb-1'>
							{t('privacy.point7.title')}
						</h2>
						<p>
							{t('privacy.point7.desc')}
						</p>

						<h2 className='tw-text-2xl tw-font-bold tw-mt-8 tw-mb-1'>
							{t('privacy.point8.title')}
						</h2>
						<p>
							{t('privacy.point8.desc')}
						</p>

						<h2 className='tw-text-2xl tw-font-bold tw-mt-8 tw-mb-1'>
              {t('privacy.point9.title')}
						</h2>
						<p dangerouslySetInnerHTML={{__html: t('privacy.point9.desc')}} />
					</div>
				</div>
			</div>
		</div>
	)
}

export default PrivacyPilicy

export async function getStaticProps() {
	const locale = 'id'
	return {
		props: {
			...(await serverSideTranslations(locale, ['footer', 'navbar', 'privacy-policy'])),
		},
	}
}
